import Vue from 'vue';
import moment from 'moment';

Vue.filter('capitalize', value => value
  .split(' ')
  .map(val => val.charAt(0).toUpperCase() + val.substr(1).toLowerCase())
  .join(' '));

Vue.filter('formatMoney', (value) => {
  value /= 100;
  return `$${value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
});

Vue.filter('formatDate', (value) => {
  if (value === 'N/A') {
    return value;
  }
  return moment(value).format('MMMM D, YYYY');
});

Vue.filter('formatShortDateTime', (value) => {
  if (value === 'N/A') {
    return value;
  }
  return moment(value).format('MM/DD/YYYY hh:mma');
});

Vue.filter('formatShortDate', value => moment(value).format('MM/DD/YYYY'));

Vue.filter('formatDateAgo', value => moment(value).from(moment()));

Vue.filter('truncate', (text, length, clamp) => {
  clamp = clamp || '...';
  const node = document.createElement('div');
  node.innerHTML = text;
  const content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
});